import * as Quotes from '../slices/quotesSlice';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { useNavigate } from 'react-router-dom';
import { AnyAction } from '@reduxjs/toolkit';
import { getUkDate } from '../utilities';

const QuoteListItem = (item: Quotes.quoteListState) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const user = useAppSelector((state) => state.user);

	const actionOnRow = (item: Quotes.quoteListState) => {
		const selquote = () => new Promise((resolve) => resolve(dispatch((Quotes.selectQuote(item.quoteid)) as unknown as AnyAction)));
		selquote().then(() => navigate('/loadquote'));
	}

	return (
		<div className="row">
			{item.visible &&
				<div className="hover" style={{ padding: '16px 0px', borderBottom: '1px solid #F4941E', fontSize: 13 }} onClick={() => actionOnRow(item)}>
					<div style={{ alignItems: 'center' }} className="row100" key={item.quoteid}>
						<div className="flexGrow1" style={{ padding: '0 0px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8 }}>{item.quoteid}</div>
						</div>
						<div className="flexGrow1" style={{ padding: '0 0px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8 }}>{item.type}</div>
						</div>
						<div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8 }}>{item.name}</div>
						</div>
						{user.id === "128568" && <div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8 }}>{item.nhgStaffName}</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8 }}>{item.consultant}</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8 }}>{item.site}</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8 }}>{item.developer}</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8 }}>{item.plsSalesStaff}</div>
						</div>}
						<div className="flexGrow1" style={{ padding: '0 0px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 4, marginRight: 8 }}>{getUkDate(item.created)}</div>
						</div>
						<div className="flexGrow1" style={{ padding: '0 0px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 16, marginRight: 8 }}>{getUkDate(item.generated)}</div>
						</div>
						<div className="flexGrow1" style={{ padding: '0 0px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 18, marginRight: 8 }}>{getUkDate(item.accepted)}</div>
						</div>
						<div className="flexGrow1" style={{ padding: '0 0px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 18, marginRight: 8 }}>{getUkDate(item.instructed)}</div>
						</div>
						{user.id === "566278" && <div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 16, marginRight: 8 }}>{item?.cpData?.ClientCareCompleteDate}</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 16, marginRight: 8 }}>{item?.cpData?.InfoMoniesOnAccountReceivedDate}</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2" style={{ padding: '0 0px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 16, marginRight: 8 }}>{item?.cpData?.IntroducerVoucherTriggerDate}</div>
						</div>}
					</div>
				</div>
			}
		</div>
	);
}

export default QuoteListItem;